import operatorApiFetch from './apiService';

const operatorMenuService = {
  // 獲取當前 operator 的選單設定
  async getMenuSettings() {
    try {
      // 加上 timestamp 避免瀏覽器快取
      const response = await operatorApiFetch(`operator_menus?_t=${Date.now()}`, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache'
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data || [];
    } catch (error) {
      console.error('Failed to fetch menu settings:', error);
      throw error;
    }
  },

  // 批量更新選單設定
  async batchUpdate(menuItems) {
    try {
      const response = await operatorApiFetch('operator_menus/batch_update', {
        method: 'POST',
        body: { menu_items: menuItems }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Failed to update menu settings:', error);
      throw error;
    }
  },

  // 重置選單設定
  async reset() {
    try {
      const response = await operatorApiFetch('operator_menus/reset', {
        method: 'POST'
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Failed to reset menu settings:', error);
      throw error;
    }
  },

  // 切換 pin 狀態
  async togglePin(menuKey) {
    try {
      const response = await operatorApiFetch('operator_menus/toggle_pin', {
        method: 'POST',
        body: { menu_key: menuKey }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Failed to toggle pin:', error);
      throw error;
    }
  }
};

export default operatorMenuService;
